import React from 'react';
import { ArrowIcon } from '../../../eagerlyIcons/src/__generated__/icons';

const PromoCard = ({ animationDelay, currentConfig }) => {

  return (
    <li className="featured__item" style={animationDelay}>
      <a className="featured__item_link" href={'#'}>
        <article className="promo-item">
          <div className="promo-item__content">
            <h5 className="agenda-item__day">Avondje lachen?</h5>
				<p>Bekijk al het cabaret aanbod</p>
          </div>
			 <ArrowIcon />
        </article>
      </a>
    </li>
  );
};

export default PromoCard;
